import * as React from "react"
import { format } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"
import { ru } from "date-fns/locale"

import { cn } from "../../lib/utils"
import { Button } from "./button"
import { Calendar } from "./calendar"
import { Popover, PopoverContent, PopoverTrigger } from "./popover"

function DatePicker({ className, value, onChange, markedDates = [], placeholder = "Выберите дату", ariaLabel, id }) {
  const [open, setOpen] = React.useState(false)

  // Функция для обработки выбора даты
  const handleSelect = (date) => {
    onChange(date)
    setOpen(false) // Закрываем календарь после выбора даты
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          id={id}
          aria-label={ariaLabel}
          variant="outline"
          className={cn(
            "w-full justify-start text-left font-normal",
            !value && "text-muted-foreground",
            className
          )}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {value ? format(value, "dd.MM.yyyy", { locale: ru }) : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={value}
          onSelect={handleSelect}
          initialFocus
          disabled={(date) => date > new Date() || date < new Date("1900-01-01")}
          markedDates={markedDates}
        />
      </PopoverContent>
    </Popover>
  )
}

export { DatePicker }
